import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import { required } from '@ps/web-shared-validators';
import React, { useEffect } from 'react';
import { useField } from 'react-final-form';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import countries from '@swf/generated/countries.json';

import CountrySelect from '../../../../../CountrySelect/CountrySelect';
import RMFDropDown from '../../../RMFDropDown/RMFDropDown';

import {
  TXTCLI_Citizenship,
  TXTMOB_Select_your_citizenship
} from './SelectCitizenship.messages.json';

interface Props {
  onRomanianCitizenship?(): void;
}

const SelectCitizenship: React.FC<Props> = ({ onRomanianCitizenship }) => {
  const siteId = useSelector(select.cms.getSiteId);
  const {
    input: { value: citizenship }
  } = useField('citizenship', { subscription: { value: true } });

  useEffect(() => {
    if (citizenship === 'RO' && siteId === Sites.ROM) onRomanianCitizenship?.();
  }, [citizenship, onRomanianCitizenship, siteId]);

  return (
    <CountrySelect name="citizenship" title={TXTCLI_Citizenship} hideSelect>
      <RMFDropDown
        id="citizenship"
        options={countries}
        label={TXTCLI_Citizenship}
        validators={[required(null)]}
        placeholder={<Translation {...TXTMOB_Select_your_citizenship} />}
      />
    </CountrySelect>
  );
};

export default SelectCitizenship;
